module.exports = __webpack_public_path__ + "VIPV37.png?8714406e83ee1c6f5a405ddb0b3393f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV37.png
// module id = 133
// module chunks = 0